import { render, staticRenderFns } from "./TagReference.vue?vue&type=template&id=01aadf2c&scoped=true&"
import script from "./TagReference.vue?vue&type=script&lang=js&"
export * from "./TagReference.vue?vue&type=script&lang=js&"
import style0 from "./TagReference.vue?vue&type=style&index=0&id=01aadf2c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01aadf2c",
  null
  
)

export default component.exports